import { Button, Dropdown, Flex, Form } from 'antd';
import React from 'react';
import { GlobalOutlined, LoadingOutlined } from '@ant-design/icons';
import './index.scss';
import { useLanguage } from 'hooks/Languages/useLanguage';
import { capitalize } from 'utils/capitalizeWords';
import { usePlatformConfig } from 'hooks/PlatformContext';

interface AuthInputFormProps {
  title: string;
  children: React.ReactNode;
  form?: any;
  onFinish?: () => void;
  registerForm?: any;
  isRegistration?: boolean;
}

const AuthInputForm: React.FC<AuthInputFormProps> = ({
  title,
  children,
  form,
  onFinish,
  isRegistration,
}) => {
  const plateText = usePlatformConfig();
  const { menuProps, currentLang, isLoading, translate } = useLanguage();
  const loading = isLoading;

  return (
    <Flex
      vertical
      align="center"
      className="auth-input-form__content"
      style={{ overflow: 'hidden' }}
    >
      <div className="top-input-form__items">
        <Flex style={{ width: '100%' }} justify="space-between" align="center">
          <span className="large-text font-weight-bold">
            {plateText?.appName}
          </span>
          <Dropdown menu={menuProps} trigger={['click']}>
            <Button
              type="text"
              onClick={(e) => e.preventDefault()}
              className="lang-button"
            >
              <Flex gap="small" align="center">
                <span className="medium-text">
                  {!loading && capitalize(currentLang?.label)}
                </span>
                {loading && <span>{translate('Loading')}...</span>}
                {loading ? (
                  <LoadingOutlined />
                ) : (
                  <GlobalOutlined className="medium-text" />
                )}
              </Flex>
            </Button>
          </Dropdown>
        </Flex>
      </div>

      <Flex className="form-items__box large-margin-bottom" vertical>
        {isRegistration ? (
          <span className="large-text large-margin-bottom">{title}</span>
        ) : (
          <span
            className="xlarge-text xlarge-margin-bottom"
            style={{ alignSelf: 'center' }}
          >
            {title}
          </span>
        )}
        <Form
          initialValues={{ ...form }}
          onFinish={onFinish}
          form={form}
          layout="vertical"
        >
          {children}
        </Form>
      </Flex>
    </Flex>
  );
};

export default AuthInputForm;
